import { render, staticRenderFns } from "./detailModel.vue?vue&type=template&id=4f1fa5e4&scoped=true&"
import script from "./detailModel.vue?vue&type=script&lang=js&"
export * from "./detailModel.vue?vue&type=script&lang=js&"
import style0 from "./detailModel.vue?vue&type=style&index=0&id=4f1fa5e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1fa5e4",
  null
  
)

export default component.exports